// @flow
import React from 'react';
import {
  compose,
  defaultProps,
  setDisplayName,
  withHandlers,
} from 'recompose';
import Available from './Available';
import Taken from './Taken';
import Void from './Void';
// $FlowFixMe
import * as r from 'ramda';
import { withBreakpoints } from '@ux/responsive';
import { DomainStatus } from '../../../core/constants';

// @TODO josh need a `status` map adding to the component mapped to DomainStatus
const isStatus = r.propEq('status');
const isAvailable = isStatus(DomainStatus.AVAILABLE);
const isPromo = isStatus(DomainStatus.PROMO);
const isTaken = isStatus(DomainStatus.TAKEN);
const isVoid = isStatus(DomainStatus.VOID);

export const PureExactMatch = r.cond([
  [ isAvailable, (props) => (
    <Available {...props}/>
  ) ],
  [ isPromo, (props) => (
    <Available
      isPromo={true}
      {...props}
    />
  ) ],
  [ isTaken, (props) => (
    <Taken {...props}/>
  ) ],
  [ isVoid, (props) => (
    <Void {...props}/>
  ) ],
  [ r.T, (props) => (
    <Available {...props}/>
  ) ],
]);

// type Props = {
//   status: string,
//   availability: string,
//   price: number,
//   oldPrice: number,
//   fqdn: string,
//   showPrice: boolean,
// };

export const enhance = compose(
  setDisplayName('ExactMatch'),
  defaultProps({
    intlNamespace: 'exactMatch',
  }),
  withBreakpoints,
  withHandlers({
    onViewBasketClick: ({ onViewBasketClick }) => () => {
      onViewBasketClick('exact');
    },
    onPurchaseBundleClick: ({
      fqdn,
      bundleDomains,
      onPurchaseBundleClick,
    }) => () => {
      onPurchaseBundleClick(fqdn, r.map(r.prop('fqdn'), bundleDomains));
    },
    handlePurchaseDomainClick: ({
      fqdn,
      onPurchaseDomainClick,
    }) => () => onPurchaseDomainClick(fqdn),
    handleTransferDomainClick: ({
      fqdn,
      onTransferDomainClick,
    }) => () => onTransferDomainClick(fqdn),
    handleBackorderDomainClick: ({
      fqdn,
      onBackorderDomainClick,
    }) => () => onBackorderDomainClick(fqdn),
    handleNegotiateDomainClick: ({
      fqdn,
      onNegotiateDomainClick,
    }) => () => onNegotiateDomainClick(fqdn),
  }),
);

export default enhance(PureExactMatch);
